// frontend/src/components/constants/currencies.js
export const currencies = [
  { code: 'USD', symbol: '$', position: 'left', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', position: 'left', name: 'Euro' },
  { code: 'RUB', symbol: ' руб ', position: 'right', name: 'Russian Ruble' },
  { code: 'KGS', symbol: ' сом ', position: 'right', name: 'Kyrgyz Som' },
  { code: 'KZT', symbol: '₸', position: 'right', name: 'Kazakhstani Tenge' },
  { code: 'UZS', symbol: ' сўм ', position: 'right', name: 'Uzbekistani Som' },
  { code: 'TJS', symbol: ' смн ', position: 'right', name: 'Tajikistani Somoni' },
  { code: 'CNY', symbol: '¥', position: 'left', name: 'Chinese Yuan' },
  { code: 'JPY', symbol: '¥', position: 'left', name: 'Japanese Yen' },
  { code: 'KRW', symbol: '₩', position: 'left', name: 'South Korean Won' },
  { code: 'VND', symbol: '₫', position: 'right', name: 'Vietnamese Dong' },
  { code: 'THB', symbol: '฿', position: 'left', name: 'Thai Baht' },
  { code: 'AMD', symbol: '֏', position: 'right', name: 'Armenian Dram' },
  { code: 'GEL', symbol: '₾', position: 'right', name: 'Georgian Lari' },
  { code: 'UAH', symbol: '₴', position: 'right', name: 'Ukrainian Hryvnia' },
  { code: 'MNT', symbol: '₮', position: 'right', name: 'Mongolian Tugrik' }
];